import {IDatasetConfig, DatasetActionOpenType, ListViewItemTypes } from 'app/interfaces';
import {fieldsMap} from './fields';
import generalForm from './forms/general.form';
import { IDataContainerService } from 'app/interfaces/data-container.interface';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { datasetDetailPage } from 'app/helpers/dataset-routing.helper';

const beforeCallDetail = {
	name: 'record',
	path: '/dataset/entity_staff_elements/detail/:recordId',
	params: {
		with_relations: 'entity'
	}
};

export const EntityStaffElementConfig: IDatasetConfig = {
	name: 'entity_staff_elements',
	title: 'Staff',
	singleTitle: 'Staff',
	ajaxDatasetCode: 'entity_staff_elements',
	fieldsMap: fieldsMap,
	supportProperties: true,
	enabledActions: {
		detail: true,
		create: true,
		edit: true,
		list: true
	},
	formConfigsMap: {
		generalForm
	},
	fetchConfig: {
		with_relations: 'entity'
	},
	defaultActions: {
		detail: {
			openType: DatasetActionOpenType.PAGE,
			beforeCalls: [ beforeCallDetail ],
			viewConfig: {
				formConfig: generalForm,
				actions: {
					edit: true,
					delete: false
				}
			}
		},
		create: {
			openType: DatasetActionOpenType.DIALOG,
			viewConfig: {
				formConfig: generalForm
			}
		},
		edit: {
			openType: DatasetActionOpenType.PAGE,
			viewConfig: {
				formConfig: generalForm
			},
		},
		list: {
			openType: DatasetActionOpenType.PAGE,
			getCallParams(dataContainerService: IDataContainerService, parenteData: any, params: any) {
				params.with_relations = 'entity';
				return params;
			},
			viewConfig: {
				itemViewType: ListViewItemTypes.TABLE,
				showSearchBar: true,
				defaultSortBy: 'description',
				defaultSortDirection: 'asc',
				columns: [
					{
						title: 'Codice',
						key: 'code',
						routerLink(record: any): string{
							return datasetDetailPage('entities', record.entity_id);
						}
					},
					{
						title: 'Descrizione',
						key: 'entity.description'
					}
				],
				customActions: [
					{
						buttonIcon: '',
						buttonColor: 'accent',
						showIf(): boolean{ return true; },
						onClick(event: any, record: any, dataContainerService: IDataContainerService, datasetNavigatorService: DatasetNavigatorService): void{
							datasetNavigatorService.showDatasetDetail('entities', null, record.entity_id);
						}
					}
				],
				actions: ['create', 'delete']
			}
		}
	}
};
